import { BankGateway, Button, DepositInput, InfoBox, TransactionList, wordifyRials } from '@sabavision/dio'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { depositRequest, ListTransactionRequest } from '../../api/financial'
import axios from '../../api/requestInterceptor'
import { Istate } from '../../reducers/types'
import Validate from '../../validations'
import depositValidator from '../../validations/schema/deposit'
import { DataContainer, DepositContainer } from './styled'
import { ITransactionData } from '../../api/types'

function Diposit() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const { userId } = useParams()

  // headless & user
  const headless = useSelector((state: Istate) => state.headless)
  const user = useSelector((state: Istate) => state.user)

  const [amount, setAmount] = useState<string>('')
  const [gateway, setGateway] = useState<string>('zarinpal')
  const [depositLoading, setDepositLoading] = useState<boolean>(false)
  const [transactions, setTransactions] = useState<any[]>([])
  const [error, setErrors] = useState<Record<string, string | null>>({})

  useEffect(() => {
    handleListTransactionRequest()
  }, [])

  const validationData = () => {
    let valid = true
    const constrains = depositValidator(user.type)
    let err = {}
    const errorMessage = Validate({ amount }, 'amount', constrains)
    err = { ...err, amount: errorMessage }
    if (errorMessage) {
      valid = false
    }
    setErrors({ ...err })
    return valid
  }

  const handleRequest = () => {
    setDepositLoading(true)
    const data = {
      amount: Number(amount),
      gateway
    }
    depositRequest(
      user.unique_id,
      data,
      (response: any) => {
        window.location.href = `${axios.defaults.baseURL}/users/${userId}/transactions/${response.data.unique_id}/pay?gateway=${gateway}`
      },
      (error: any) => {
        console.log(error)
        setDepositLoading(false)
      }
    )
  }

  const handleSubmit = () => {
    const valid = validationData()
    if (valid) {
      handleRequest()
    }
  }

  const handleListTransactionRequest = () => {
    const requestData: ITransactionData = {
      // method: ['deposit', 'reject_withdraw', 'increase_by_admin', 'prepaid_increase', 'increase_wallet', 'increase_from_old_panel'],
      method: ['deposit'],
      page: 1,
      page_size: 10,
      section: 'advertiser'
    }

    ListTransactionRequest(
      userId,
      requestData,
      (res) => {
        let temp = []
        const result = res.data.data
        temp = result.map((item: any) => {
          return {
            unique_id: item.unique_id || Math.floor(Math.random() * 10e10),
            trace_number: item.trace_number || '-',
            amount: Number(item.amount) || 0,
            date: item.paid_at ? new Date(item.paid_at) : new Date(item.created_at),
            status: item.status
          }
        })
        setTransactions(temp)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  const goToReceipt = () => {
    localStorage.setItem('amount', amount)
    window.open(`/users/${userId}/invoice/pre-receipt`, '_blank')
  }

  return (
    <DataContainer>
      <div className="max-container">
        <DepositContainer>
          <DepositInput
            handleChange={(value) => {
              setErrors({})
              setAmount(value)
            }}
            label={t('deposit_amount')}
            name="amount"
            currency="rial"
            error={error.amount && t(error.amount)}
          />

          <InfoBox
            getReceiptOption
            goToReceipt={goToReceipt}
            message={t('deposit_amount_condition', {
              amount: new Intl.NumberFormat('fa-IR').format(
                Math.trunc(
                  headless.transaction?.deposit?.attributes?.amount?.logics?.greaterThanOrEqualTo[user?.type] / 10
                )
              ),
              amount_in_words: wordifyRials(
                Math.trunc(headless.transaction?.deposit?.attributes?.amount?.logics?.greaterThanOrEqualTo[user?.type])
              )
            })}
          />

          <BankGateway
            label={t('bank_gateways')}
            values={[
              {
                id: '1',
                bankLogoURL: 'https://plus.sabavision.com/assets/statics/images/bank-logo/zarinpal.png',
                bankName: 'زرین پال',
                disabled: false,
                checked: true
              },
              {
                id: '4',
                bankLogoURL: 'https://plus.sabavision.com/assets/statics/images/bank-logo/eghtesad-novin-bank.svg',
                bankName: 'اقتصاد نوین',
                disabled: true
              },
              {
                id: '5',
                bankLogoURL: 'https://plus.sabavision.com/assets/statics/images/bank-logo/parsian-bank.svg',
                bankName: 'پارسیان',
                disabled: true
              }
            ]}
            handleClick={() => {
              setGateway('zarinpal')
            }}
          />

          <Button
            data-test="button-deposit"
            label={t('pay')}
            fullWidth
            radius="10px"
            fontSize="12px"
            dotsLoading={depositLoading}
            handleClick={() => {
              handleSubmit()
            }}
          />
        </DepositContainer>
      </div>

      <span className="divider" style={{ marginTop: '25px' }}>
        <span>
          <span className="iconsax-cards"></span>
          <span>{t('deposit_amount_history')}</span>
        </span>
      </span>

      <div style={{ width: '100%' }}>
        {!!transactions.length && (
          <TransactionList
            data={transactions}
            handleScrollToBottom={() => {
              console.log()
            }}
          />
        )}
      </div>
    </DataContainer>
  )
}

export default Diposit
